import { IOfficialDiaryDetailResponse } from '../../../../model/sdp/official-daily/response/official-diary-detail-response';
import { FileBase64 } from '../../../../model/file-base-64';

export type OfficialDiaryDetailState = {
  officialDiaryDetail: IOfficialDiaryDetailResponse;
  officialDiaryFile: FileBase64;
  loading: boolean;
};

export enum ACTION_TYPES {
  setOfficialDiaryDetail = 'setOfficialDiaryDetail',
  setOfficialDiaryFile = 'setOfficialDiaryFile',
  setLoading = 'setLoading',
}

export const OfficialDiaryDetailReducer = (state: OfficialDiaryDetailState, action: any): OfficialDiaryDetailState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setOfficialDiaryDetail:
      return {
        ...state,
        officialDiaryDetail: payload,
      };
    case ACTION_TYPES.setOfficialDiaryFile:
      return {
        ...state,
        officialDiaryFile: payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
